import { message } from 'antd';
import apiClient from '../api/apiClient';
import { isSubscriptionRestrictionCode } from './subscriptionAccessEvents';

// Les exports assemblés localement doivent demander au serveur la décision
// effective de l'entreprise sélectionnée juste avant la création du fichier.
export async function ensureSubscriptionActionAllowed(action) {
  try {
    const response = await apiClient.get(
      `/api/subscription/me/action-access/${encodeURIComponent(action)}`,
    );
    if (response.data?.allowed === true) return true;
    message.error(response.data?.message || 'Cette action est momentanément indisponible.');
  } catch (error) {
    if (!isSubscriptionRestrictionCode(error?.response?.data?.code)) {
      message.error(
        error?.response?.data?.message ||
        'Impossible de vérifier votre accès à cette action. Réessayez dans un instant.',
      );
    }
  }
  return false;
}
